// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"a9536fec","453":"fd2f0c4a","943":"a82d55c7"}[chunkId] + ".chunk.js";
};